module.exports = "<svg ng-style=\"{height: '60px', width: $ctrl.width + 'px'}\" style=\"display: block\">\n  <g class=\"heatmap-component\">\n  </g>\n</svg>\n"